// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"eb7d94fa","787":"ea98b908"}[chunkId] + ".chunk.js";
};